import { FunctionComponent, PropsWithChildren } from 'react'
import { Login } from 'pages/auth/Login'

interface Props extends PropsWithChildren {}

export const AuthChecker: FunctionComponent<Props> = ({ children }) => {
  const isLoggedIn = false

  if (!isLoggedIn) {
    return <>{children}</>
  } else {
    return <Login />
  }
}
